import React from 'react'
import Icon from '../Icon/Icon.tsx'
import Typography from '../Typography/Typography.tsx'
import TextField from '../TextField/TextField'

type Option = {
    value?: any
    text?: React.ReactNode
    title?: boolean
    selected?: boolean
    icon?: string
    disabled?: boolean
}

type Props = {
    dataTestId: string
    filteredOptions: Option[]
    menuClasses: Record<string, string>
    search: string
    searchPlaceholder: string
    clearSearch(event?: React.SyntheticEvent): void
    setSearch(value: string): void
    onSelect(value: any): void
    selectedValue: any
}

const stickySearchStyles = {
    backgroundColor: 'white',
    padding: '10px 18px 10px',
    borderBottom: '1px solid #D9D8D8'
} as React.CSSProperties

const dropdownListStyles = {
    maxHeight: '260px',
    overflowY: 'auto',
    position: 'relative'
} as React.CSSProperties

/**
 *
 */
const SearchableSelectMenu = ({
    dataTestId,
    filteredOptions,
    menuClasses,
    search,
    searchPlaceholder,
    clearSearch,
    setSearch,
    onSelect,
    selectedValue
}: Props): JSX.Element => {
    return (
        <div className={menuClasses.dropdownContainer} data-testid={`${dataTestId}-menu`}>
            <div className={`${menuClasses.dropdown} dropdown--full-width select-menu`} style={{ width: '100%', minWidth: '100%', maxHeight: 'none', overflowY: 'hidden' }}>
                <div style={stickySearchStyles}>
                    <TextField
                        value={search}
                        onChange={setSearch}
                        label={searchPlaceholder}
                        fullWidth={true}
                        trailingIcon={search ? 'close' : undefined}
                        onClickTrailingIcon={clearSearch}
                        data-testid={`${dataTestId}-search`}
                    />
                </div>
                <div style={dropdownListStyles}>
                    {filteredOptions.map((item, index) => {
                        const isSelected = item.value && item.value === selectedValue
                        return (
                            <div
                                key={item.value}
                                onClick={() => !item.disabled && onSelect(item.value)}
                                className={`
                                    ${item.title ? menuClasses.dropdownTitle : menuClasses.dropdownItem}
                                    ${item.disabled ? menuClasses.dropdownDisabled : ''}
                                    ${isSelected ? menuClasses.selectedItem : ''}
                                `}
                                style={{
                                    borderTop: item.title && index > 0 ? '1px solid #D9D8D8' : 'none',
                                    borderBottom: index === filteredOptions.length - 1 ? 'none' : undefined
                                }}
                                data-testid={`${dataTestId}-item-${index}`}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {item.text}
                                </div>
                                {isSelected && (
                                    <div style={{ paddingRight: '10px' }}>
                                        <Icon name='check' color='neutral-700' size={20} />
                                    </div>
                                )}
                            </div>
                        )
                    })}
                    {!filteredOptions?.length && (
                        <div className={menuClasses.noData}>
                            <Typography variant='subtitle3'>No data available</Typography>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SearchableSelectMenu
